import React from "react";
import AppButton from "../../../../shared/components/generic/button/app-button";
import Pagination from "../../../../shared/components/generic/pagination/pagination";
import TableGeneric from "../../../../shared/components/generic/table/table-generic";

const AssessmentTable = ({
	columns,
	data,
	rowKey = "id",
	pageCount,
	currentPage,
	onPageChange,
	onExport
}) => (
	<>
		<div className="apuracao__table-actions">
			<AppButton
				type="button"
				className="apuracao__export-button"
				startIcon="file"
				startIconSize={14}
				onClick={onExport}
			>
				Exportar Excel
			</AppButton>
		</div>

		<div className="apuracao__table">
			<TableGeneric
				columns={columns}
				data={data}
				rowKey={rowKey}
			/>
		</div>

		{pageCount > 1 && (
			<Pagination
				pageCount={pageCount}
				currentPage={currentPage}
				onPageChange={onPageChange}
			/>
		)}
	</>
);

export default AssessmentTable;